module.exports = __webpack_public_path__ + "images/emoji/anguished.c533fbff99e3d8d0e825.png";